export type BombiixStatusPillTone = 'approved' | 'pending' | 'rejected' | 'neutral';

export interface BombiixStatusPillProps {
  /** Left label — how the document arrived, e.g. "Uploaded". */
  leadingLabel: string;
  /** Right label — where it got to, e.g. "Approved". Omit for a single-label pill. */
  label?: string;
  /** Fill colour. `neutral` is the grey header fill, used when a status has no mapping. */
  tone?: BombiixStatusPillTone;
  className?: string;
}

const TONE_CLASS: Record<BombiixStatusPillTone, string> = {
  approved: 'bombiix-status-pill--approved',
  pending: 'bombiix-status-pill--pending',
  rejected: 'bombiix-status-pill--rejected',
  neutral: '',
};

/**
 * BombiixStatusPill — split status pill (Figma nodes 15059:455297 / 15059:455311).
 * One flat fill carries the state; both labels stay Bombiix Black and a hairline
 * rule separates them. Styling lives in `_status-pill.scss`.
 * @param {BombiixStatusPillProps} props - Component props.
 * @returns {React.ReactElement} The pill.
 */
function BombiixStatusPill({ leadingLabel, label, tone = 'neutral', className }: BombiixStatusPillProps) {
  const rootClass = ['bombiix-status-pill', TONE_CLASS[tone], className].filter(Boolean).join(' ');
  return (
    <span className={rootClass}>
      <span className="bombiix-status-pill__label">{leadingLabel}</span>
      {label ? (
        <>
          <span className="bombiix-status-pill__divider" aria-hidden="true" />
          <span className="bombiix-status-pill__label">{label}</span>
        </>
      ) : null}
    </span>
  );
}

export default BombiixStatusPill;
